import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

//用户登录
import userStates from './user/states'
import userMutations from './user/mutations'
import userActions from './user/actions'

//备课
//课程建设
import jxCourseStates from './jxCourse/states'
import jxCourseMutations from './jxCourse/mutations'
import jxCourseActions from './jxCourse/actions'

//授课计划
import skPlanStates from './skPlan/states'
import skPlanMutations from './skPlan/mutations'
import skPlanActions from './skPlan/actions'

//预习任务
import yxTaskStates from './yxTask/states'
import yxTaskMutations from './yxTask/mutations'
import yxTaskActions from './yxTask/actions'


//课中活动
import kzActivityStates from './kzActivity/states'
import kzActivityMutations from './kzActivity/mutations'
import kzActivityActions from './kzActivity/actions'


//课后拓展
import khExpandStates from './khExpand/states'
import khExpandMutations from './khExpand/mutations'
import khExpandActions from './khExpand/actions'


//教学班级
import jxClassStates from './jxClass/states'
import jxClassMutations from './jxClass/mutations'
import jxClassActions from './jxClass/actions'

//在线答疑
import chatStates from './chat/states'
import chatMutations from './chat/mutations'
import chatActions from './chat/actions'

//公用
import globalStates from './global/states'
import globalMutations from './global/mutations'
import globalActions from './global/actions'

//成效
import effectStates from './effect/states'
import effectMutations from './effect/mutations'
import effectActions from './effect/actions'

import module from './module'

//授课
//课程列表
import skIndexStates from './give-course/index/states'
import skIndexMutations from './give-course/index/mutations'
import skIndexActions from './give-course/index/actions'

//课中签到
import skSiginStates from './give-course/sigin/states'
import skSiginMutations from './give-course/sigin/mutations'
import skSiginActions from './give-course/sigin/actions'

//预习任务
import skYXTaskStates from './give-course/yxTask/states'
import skYXTaskMutations from './give-course/yxTask/mutations'
import skYXTaskActions from './give-course/yxTask/actions'

//讨论
import skDiscussStates from './give-course/discuss/states'
import skDiscussMutations from './give-course/discuss/mutations'
import skDiscussActions from './give-course/discuss/actions'

//互动举手
import skInteractStates from './give-course/interact/states'
import skInteractMutations from './give-course/interact/mutations'
import skInteractActions from './give-course/interact/actions'

//作业
import skHomeWorkStates from './give-course/homeWork/states'
import skHomeWorkMutations from './give-course/homeWork/mutations'
import skHomeWorkActions from './give-course/homeWork/actions'

//问卷
import skInquiryStates from './give-course/inquiry/states'
import skInquiryMutations from './give-course/inquiry/mutations'
import skInquiryActions from './give-course/inquiry/actions'

//互评
import skCommentStates from './give-course/comment/states'
import skCommentMutations from './give-course/comment/mutations'
import skCommentActions from './give-course/comment/actions'

//测验
import skTestStates from './give-course/test/states'
import skTestMutations from './give-course/test/mutations'
import skTestActions from './give-course/test/actions'

//调查
import skVoteStates from './give-course/vote/states'
import skVoteMutations from './give-course/vote/mutations'
import skVoteActions from './give-course/vote/actions'

//画像
import skPortrayalStates from './give-course/portrayal/states'
import skPortrayalMutations from './give-course/portrayal/mutations'
import skPortrayalActions from './give-course/portrayal/actions'

//其他
import skOtherStates from './give-course/other/states'
import skOtherMutations from './give-course/other/mutations'
import skOtherActions from './give-course/other/actions'

//学情
import situationStates from './situation/states'
import situationMutations from './situation/mutations'
import situationActions from './situation/actions'

import giveCourse from './giveCourse'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    //备课
    ...userStates, //用户登录
    ...jxCourseStates, //课程建设
    ...skPlanStates, //授课计划
    ...yxTaskStates, //预习任务
    ...kzActivityStates, //课中活动
    ...khExpandStates, //课后拓展
    ...jxClassStates, //教学班级
    ...chatStates, //在线答疑
    ...globalStates, //公用
    ...effectStates, //成效
    //授课
    ...skIndexStates, //首页
    ...skSiginStates, //签到
    ...skYXTaskStates, //预习任务
    ...skDiscussStates, //讨论
    ...skInteractStates, //互动举手
    ...skHomeWorkStates, //作业
    ...skInquiryStates, //问卷
    ...skCommentStates, //互评
    ...skTestStates, //测验
    ...skVoteStates, //调查
    ...skPortrayalStates, //画像

    ...skOtherStates, //其他
    ...situationStates,//学情
  },
  mutations: {
    ...userMutations, //用户登录
    ...jxCourseMutations, //课程建设
    ...skPlanMutations, //授课计划
    ...yxTaskMutations, //预习任务
    ...kzActivityMutations, //课中活动
    ...khExpandMutations, //课后拓展
    ...jxClassMutations, //教学班级
    ...chatMutations, //在线答疑
    ...globalMutations, //公用
    ...effectMutations, //成效
    //授课
    ...skIndexMutations, //首页
    ...skSiginMutations, //签到
    ...skYXTaskMutations, //预习任务
    ...skDiscussMutations, //讨论
    ...skInteractMutations, //互动举手
    ...skHomeWorkMutations, //作业
    ...skInquiryMutations, //问卷
    ...skCommentMutations, //互评
    ...skTestMutations, //测验
    ...skVoteMutations, //调查
    ...skPortrayalMutations, //画像

    ...skOtherMutations, //其他
    ...situationMutations, //其他
  },
  actions: {
    ...userActions, //用户登录
    ...jxCourseActions, //课程建设
    ...skPlanActions, //授课计划
    ...yxTaskActions, //预习任务
    ...kzActivityActions, //课中活动
    ...khExpandActions, //课后拓展
    ...jxClassActions, //教学班级
    ...chatActions, //在线答疑
    ...globalActions, //公用
    ...effectActions, //公用
    //授课
    ...skIndexActions, //首页
    ...skSiginActions, //签到
    ...skYXTaskActions, //预习任务
    ...skDiscussActions, //讨论
    ...skInteractActions, //互动举手
    ...skHomeWorkActions, //作业
    ...skInquiryActions, //问卷
    ...skCommentActions, //互评
    ...skTestActions, //测验
    ...skVoteActions, //调查
    ...skPortrayalActions, //画像
    
    ...skOtherActions,
    ...situationActions, //其他
  },
  modules: {
    module,
    giveCourse,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js